import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

export const CssTextField = styled(TextField)({
  "& .MuiButtonBase-root": {
    svg: {
      filter:
        "invert(150%) sepia(50%) saturate(30%) hue-rotate(103deg) brightness(115%) contrast(107%)",
    },
  },
  "& label": {
    color: "#7A819C",
  },
  "& label.Mui-focused": {
    color: "#7A819C",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "blue",
  },
  "& .MuiOutlinedInput-root": {
    color: "#8D91A9",
    width: "180px",
    height: "56px",
    "& fieldset": {
      opacity: 0.2,
      backgroundColor: "#7A819C",
    },
    "&:hover fieldset": {
      borderColor: "#7A819C",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7A819C",
    },
  },
});
